import * as React from "react";
import { useState } from "react";
import { Button, Input, InputProps, Label, MessageBar, MessageBarTitle, MessageBarBody } from "@fluentui/react-components";
import { register } from "../services/AuctionService";
import { set } from "date-fns";

export const Register = () => {
  // const initialState = { 
  //   username:'mcampulla@gmail.com', 
  //   pwd:'Gennaio2026!', 
  //   confirmpwd:'Gennaio2026!', 
  //   displayname:'Marco Campulla', 
  //   nome:'Marco', 
  //   cognome:'Campulla' 
  // };
  const initialState = { 
    username:'', 
    password:'', 
    confirmpassword:'', 
    displayname:'', 
    nome:'', 
    cognome:'' 
  };
  const [values, setValues] = useState(initialState);
  const [messages, setMessages] = useState<string[]>([]);
  const [showForm, setShowForm] = useState(true);

  const onChange: InputProps["onChange"] = (ev, data) => {
    const a = { ...values, [ev.target.name]: ev.target.value }
    setValues(a);
    verifyFields(a);    
  };

  const verifyFields = (fvalues: any): boolean => {
    let result = true;
    let message = [];
    console.log(fvalues);
    if (fvalues.username == '') {
      message.push("Il campo Username è obbligatorio");
      result = false;
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(fvalues.username)) {
      message.push("Il campo Username deve essere un indirizzo email valido");
      result = false;
    }
    if (fvalues.password == '') {
      message.push("Il campo Password è obbligatorio");
      result = false;
    }
    if (fvalues.password.length < 6) {
      message.push("La password deve contenere almeno 6 caratteri");
      result = false;
    }
    if (fvalues.confirmpassword == '') {
      message.push("Il campo Conferma Password  è obbligatorio");
      result = false;
    }
    if (fvalues.password !== fvalues.confirmpassword) {
      message.push("Le password non coincidono");
      result = false;
    }
    if (fvalues.displayname == '') {
      message.push("Il campo Display Name è obbligatorio");
      result = false;
    }
    if(!result){
      setMessages(message);
      return result;
    }
    setMessages([]);
    return result;
  }

  const registerUser = async () => {
    console.log(values);
    if (verifyFields(values)){
      const res = await register(values);   
      console.log(res);
      if(res.Success) {
        setShowForm(false);
        setValues(initialState);
      } else {
        setMessages([res.Message]);
      }
    }
  }

  return (
    <div className="container">
      <div className="page-title">REGISTRAZIONE UTENTE</div>
      {showForm && <>
        <div className="formDiv">
          <form style={{width:"100%"}}>
            <div className="row mb-3">
              <div className="col-4"><Label required htmlFor={"username"}>Email</Label></div>
              <div className="col-8"><Input required type="text" name={"username"} value={values.username || ""} onChange={onChange} /></div>
            </div>
            <div className="row mb-3">
              <div className="col-4"><Label required htmlFor={"password"}>Password</Label></div>
              <div className="col-8"><Input required type="password" name={"password"} value={values.password || ""} onChange={onChange} /></div>
            </div>
            <div className="row mb-3">
              <div className="col-4"><Label required htmlFor={"confirmpassword"}>Conferma password</Label></div>
              <div className="col-8"><Input required type="password" name={"confirmpassword"} value={values.confirmpassword || ""} onChange={onChange} /></div>
            </div>
            <div className="row mb-3">
              <div className="col-4"><Label required htmlFor={"displayname"}>Nome visualizzato</Label></div>
              <div className="col-8"><Input required type="text" name={"displayname"} value={values.displayname || ""} onChange={onChange} /></div>
            </div>
            <div className="row mb-3">
              <div className="col-4"><Label htmlFor={"nome"}>Nome</Label></div>
              <div className="col-8"><Input required type="text" name={"nome"} value={values.nome || ""} onChange={onChange} /></div>
            </div>
            <div className="row mb-3">
              <div className="col-4"><Label htmlFor={"cognome"}>Cognome</Label></div>
              <div className="col-8"><Input required type="text" name={"cognome"} value={values.cognome || ""} onChange={onChange} /></div>
            </div>        
            <div className="formButtonRow">
              <div className="col-12">
                <Button appearance="primary" onClick={registerUser}>Invia</Button>
              </div>
            </div>
          </form>
        </div>
        <div className="formErrorDiv mt-3">
          {messages.length > 0 && <MessageBar key="error" intent="error">
            <MessageBarBody>
              <MessageBarTitle>Errore:</MessageBarTitle>{messages.map((m, index) => <div key={index}>{m}</div>)}
            </MessageBarBody>
          </MessageBar>}
        </div>
      </>}
      {!showForm && 
        <div style={{margin:"auto", padding:"10px", textAlign:"center"}}>
          La registrazione è andata a buon fine, controllate la vostra email per attivare il nuovo utente.
        </div>
      }
    </div>
  );
};